const ICONS = {
  Tapware: (
    <>
      <path d="M12 21V8" />
      <path d="M12 8H5v3" />
      <path d="M12 5h4" />
      <path d="M8.5 21h7" />
    </>
  ),
  Showers: (
    <>
      <rect x="8" y="3" width="8" height="4" rx="1" />
      <path d="M12 7v2" />
      <path d="M8.5 13v2.5" />
      <path d="M12 14v2.5" />
      <path d="M15.5 13v2.5" />
    </>
  ),
  Bathtubs: (
    <>
      <path d="M4 11h16v2a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5v-2Z" />
      <path d="M7 18l-1.2 2.5" />
      <path d="M17 18l1.2 2.5" />
      <path d="M18 11V7a2 2 0 0 1 4 0" />
    </>
  ),
  Toilets: (
    <>
      <rect x="5" y="4" width="5" height="6" rx="1" />
      <path d="M10 10h7v2.5a4.5 4.5 0 0 1-4.5 4.5H11l-1 4H7.5l1-6.5" />
    </>
  ),
  Basins: (
    <>
      <circle cx="12" cy="12" r="7.5" />
      <circle cx="12" cy="12" r="2.5" />
    </>
  ),
  Sinks: (
    <>
      <rect x="3.5" y="7" width="17" height="10" rx="2" />
      <path d="M12 7v10" />
      <path d="M16 7V5a1.5 1.5 0 0 1 3 0" />
    </>
  ),
  Vanities: (
    <>
      <path d="M8 8a4 2.2 0 0 1 8 0" />
      <rect x="4.5" y="8" width="15" height="9.5" rx="1.2" />
      <path d="M4.5 12.75h15" />
      <path d="M11 10.4h2" />
      <path d="M11 15.1h2" />
    </>
  ),
  "LED Mirrors": (
    <>
      <rect x="7.5" y="3.5" width="9" height="17" rx="4.5" />
      <path d="M12 1v1" />
      <path d="M3.8 5l1.2 1.2" />
      <path d="M20.2 5 19 6.2" />
    </>
  ),
  Accessories: (
    <>
      <path d="M3.5 6.5h17" />
      <path d="M3.5 5v3" />
      <path d="M20.5 5v3" />
      <rect x="8.5" y="6.5" width="7" height="12" rx="1" />
    </>
  ),
};

const CategoryIcon = ({ category, className = "h-5 w-5" }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {ICONS[category]}
  </svg>
);

export default CategoryIcon;
